export function artworkAttachmentLabel(attachment) {
  return attachment.split('_')[1];
}
